import { render, staticRenderFns } from "./optionView.vue?vue&type=template&id=2423b9fe&scoped=true"
import script from "./optionView.vue?vue&type=script&lang=js"
export * from "./optionView.vue?vue&type=script&lang=js"
import style0 from "./optionView.vue?vue&type=style&index=0&id=2423b9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423b9fe",
  null
  
)

export default component.exports